import React from 'react'
import styles from './NavLink.module.scss'

interface ExternalNavLinkProps {
  href: string
  children: React.ReactNode
  className?: never
}

export const ExternalNavLink: React.FC<ExternalNavLinkProps> = ({ href, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={[styles.link, styles.inactive].join(' ')}
  >
    {children}
  </a>
)
